/**
 * Created by Claude on 30.01.2026
 */

LightningRushHorizontalContent = cc.Node.extend({
    ctor: function (controller, { closeWindowCallback }) {
        this._super();

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize(cleverapps.resolution.getSceneSize());

        this.controller = controller;
        this.closeWindowCallback = closeWindowCallback;

        const styles = cleverapps.styles.LightningRushWindow;

        this.layout = new cleverapps.Layout(this.listContentItems(), {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
        this.addChild(this.layout);
        this.layout.setPosition(this.width / 2, this.height / 2);
    },

    listContentItems: function () {
        const styles = cleverapps.styles.LightningRushWindow;
        const controller = this.controller;

        const table = this.createTable();
        table.setAnchorPoint(0.5, 0.5);

        const titleSlot = this.titleBg = this.backgroundSpine.getSlot("slot_title");
        const helpSlot = this.backgroundSpine.getSlot("slot_help");
        const timerSlot = this.backgroundSpine.getSlot("slot_timer");
        const timerBgSlot = this.backgroundSpine.hasSlot("slot_timer_bg") && this.backgroundSpine.getSlot("slot_timer_bg");
        const closeSlot = this.backgroundSpine.hasSlot("slot_close") && this.backgroundSpine.getSlot("slot_close");
        const clockSlot = this.backgroundSpine.getSlot("slot_clock");

        const mainTitle = cleverapps.UI.generateOnlyText(Messages.get(`Missions.${controller.getName()}.Title`), cleverapps.styles.FONTS.RIDDLES_MISSION_HOR_TITLE_TEXT);
        titleSlot.addChild(mainTitle);
        mainTitle.setAlignment(titleSlot.width / 2, titleSlot.height / 2);
        mainTitle.fitTo(titleSlot.width, titleSlot.height);

        const helpButton = this.infoButton = new cleverapps.UI.HelpButton({
            type: cleverapps.styles.UI.Button.Images.help_button_transparent,
            callback: () => {
                GuideWindow.createMissionRulesWindow(controller.getMission());
                cleverapps.tutorial.trigger("infoClicked");
            }
        });
        helpSlot.addChild(helpButton);
        helpButton.setAlignment(helpSlot.width / 2, helpSlot.height / 2);
        helpButton.setScale(styles.helpButton.scale);
        helpButton.baseScale = helpButton.scale;

        if (closeSlot) {
            const closeButton = this.tableCloseButton = new CloseRoundButton({
                onClicked: this.closeWindowCallback,
                styles: styles.closeButton
            });
            closeSlot.addChild(closeButton);
        }

        if (timerBgSlot) {
            const timerBg = new cc.Scale9Sprite(bundles.timer.frames.timer_bg_png);
            timerBg.setContentSize2(timerBgSlot.getContentSize());
            timerSlot.setLocalZOrder(1);
            timerBgSlot.addChild(timerBg);
            timerBg.setAlignment(timerBgSlot.width / 2, timerBgSlot.height / 2);
        }

        if (controller.getMission().logic.isActiveState()) {
            let timeLeft = controller.getTimeLeft();
            if (timeLeft > 0) {
                timeLeft = new cleverapps.CountDown(timeLeft, {
                    onFinish: this.closeWindowCallback
                });
            }

            const timer = new cleverapps.CountDownView(timeLeft, {
                font: cleverapps.styles.FONTS.RIDDLES_MISSION_HOR_TIMER_TEXT
            });
            timerSlot.setLocalZOrder(2);
            timerSlot.addChild(timer);
            timer.fitTo(timerSlot.width, timerSlot.height);
            timer.setAlignment(timerSlot.width / 2, timerSlot.height / 2);
        } else {
            const finishTitle = cleverapps.UI.generateOnlyText(Messages.get("Missions.windowFinished"), cleverapps.styles.FONTS.RIDDLES_MISSION_HOR_TIMER_TEXT);
            timerSlot.addChild(finishTitle);
            finishTitle.setAlignment(timerSlot.width / 2, timerSlot.height / 2);
            finishTitle.fitTo(timerSlot.width, timerSlot.height);
        }

        const clock = new cc.Sprite(bundles.timer.frames.timer_png);
        clockSlot.setLocalZOrder(2);
        clockSlot.addChild(clock);
        clock.setPosition(clockSlot.width / 2, clockSlot.height / 2);

        const button = this.createButton();

        return [table, button].filter(Boolean);
    },

    createTable: function () {
        const controller = this.controller;
        const jsons = bundles.mission_window.jsons;

        const json = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL && jsons.mission_board_vertical
            ? jsons.mission_board_vertical : jsons.mission_board;

        const background = this.backgroundSpine = new cleverapps.Spine(json);
        if (background.hasAnimation("open")) {
            background.setAnimationAndIdleAfter("open", "idle");
        } else {
            background.setAnimation(0, "idle", true);
        }

        const tableSlot = background.getSlot("slot_table");
        const table = controller.getTable();
        const tableView = this.tableView = new cleverapps.UI.ScrollView(new cc.Node(), {
            scrollBarEnabled: !table.scrollDisabled,
            mouseScroll: !table.scrollDisabled,
            dock: { toEnd: false }
        });

        new TableHandler(table, tableView, {
            id: controller.getType(),
            height: tableSlot.height,
            rowConstructor: LightningRushRowView,
            rowOptions: {
                width: tableSlot.width,
                dataIcon: bundles.tablerow_icons.frames.lighting_rush_tablerow_icon,
                mission: controller.getMission()
            }
        });

        if (background.hasSlot("slot_board_bg")) {
            const boardBgSlot = background.getSlot("slot_board_bg");
            boardBgSlot.setLocalZOrder(-1);
            const boardBg = new cc.Scale9Sprite(bundles.mission_window.frames.mission_board_bg_png);
            boardBg.setContentSize2(boardBgSlot.getContentSize());
            boardBgSlot.addChild(boardBg);
            boardBg.setAlignment(boardBgSlot.width / 2, boardBgSlot.height / 2);

            boardBgSlot.addChild(tableView);
            tableView.setAlignment(boardBgSlot.width / 2, boardBgSlot.height / 2);
        } else {
            tableSlot.addChild(tableView);
            tableView.setAlignment(tableSlot.width / 2, tableSlot.height / 2);
        }

        const skin = (Mission.GetMissionType(controller.getType()) === Mission.TYPE_EXPEDITION_FEAST ? cleverapps.meta.selectedLocationId() : "")
            + controller.getName();

        if (background.hasSkin(skin)) {
            background.setSkin(skin);
        }

        return background;
    },

    createButton: function () {
        const styles = cleverapps.styles.LightningRushWindow;
        const controller = this.controller;

        if (!controller.isPrizeState()) {
            return;
        }

        let options = {
            width: styles.button.width,
            height: styles.button.height,
            type: styles.button.red && cleverapps.styles.UI.Button.Images.button_red,
            text: Messages.get("Play").toUpperCase(),

            onClicked: function () {
                this.closeWindowCallback();

                cleverapps.focusManager.distract({
                    focus: "MissionPlayButtonPressed",
                    action: function (f) {
                        Level.WantsToPlay(f);
                    }
                });
            }.bind(this)
        };

        const prize = controller.getPrize();
        options = Object.assign(options, {
            type: cleverapps.styles.UI.Button.Images.button_blue,
            text: Messages.get(prize ? "Claim" : "Close"),
            onClicked: () => {
                this.closeWindowCallback();

                if (prize) {
                    controller.getMission().logic.receivePrize();
                }
            }
        });

        const button = new cleverapps.UI.Button(options);
        button.setAlignment(styles.button);
        return button;
    },

    onResize: function () {
        this.setContentSize(cleverapps.resolution.getSceneSize());
        this.layout.setPosition(this.width / 2, this.height / 2);
    }
});
